import classNames from "classnames";
import { FieldState } from "formstate";
import { observer } from "mobx-react";
import React from "react";
import { TooltipComponent } from "../tooltipComponent";
import styles from "./agentInput.css";

type StyleType = "default" | "signup" | "login";
interface Props extends React.HTMLProps<HTMLInputElement> {
  type?: string;
  field: FieldState<any>;
  styleType?: StyleType;
  inputRef?: React.Ref<HTMLInputElement>;
  errorTooltipPosition?: "top right" | "left" | "bottom right";
}

@observer
export class AgentInput extends React.Component<Props> {
  getStyle = (styleType?: StyleType) => {
    switch (styleType) {
      case "signup":
        return styles.signup;
      case "login":
        return styles.login;
      default:
        return undefined;
    }
  };

  onBlur = async (ev: React.FocusEvent<HTMLInputElement>) => {
    const { field, onBlur } = this.props;
    if (!!field.value) {
      await field.validate();
    }
    return onBlur ? onBlur(ev) : undefined;
  };

  onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const { field, onChange } = this.props;
    field.onChange(ev.target.value);
    field.setError("");
    return onChange ? onChange(ev) : undefined;
  };

  render() {
    const {
      errorTooltipPosition,
      field,
      type,
      className,
      styleType,
      onBlur,
      onChange,
      inputRef,
      children,
      ...inputProps
    } = this.props;
    return (
      <div
        className={classNames(styles["input-wrap"], this.getStyle(styleType), className, {
          [styles["has-error"]]: field.hasError
        })}
      >
        <input
          {...inputProps}
          value={field.value}
          type={type || "text"}
          ref={inputRef}
          onChange={this.onChange}
          onBlur={this.onBlur}
        />
        {field.hasError && (
          <TooltipComponent
            positionPreset={errorTooltipPosition || "top right"}
            text={field.error}
            maxWidth={"700%"}
            width={"600%"}
            style={"error"}
          >
            <i className={["icon-exclamation-mark", styles["error-feedback"]].join(" ")} />
          </TooltipComponent>
        )}
      </div>
    );
  }
}
